module.exports = __webpack_public_path__ + "img/logo.91e6022e.png";